import { isPlatformBrowser } from '@angular/common';
import {
    Component,
    OnInit,
    signal,
    Inject,
    PLATFORM_ID,
    inject,
    ChangeDetectorRef,
    afterNextRender,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WebengageService } from '@core/services/webengage.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { WINDOW } from './app.module';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'iho-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [],
})
export class AppComponent implements OnInit {
    title = 'ihowebsite';
    counter = 1;
    showPWA = false;
    showInstallGuide = false;
    dialog = inject(MatDialog);
    isMobile(): boolean {
        if (!isPlatformBrowser(this.platformId)) return false;

        const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
        return /iPhone|iPad|iPod|android/i.test(userAgent);
    }
    deferredPrompt: any = null;
    notification = inject(NotificationService);
    cdr = inject(ChangeDetectorRef);
    router = inject(ActivatedRoute);
    navigatorVal: any = isPlatformBrowser(this.platformId)
        ? /Android|iPhone/.test(this.window.navigator.userAgent)
        : undefined;
    constructor(private webengage: WebengageService, 
        @Inject(PLATFORM_ID) private platformId: Object,
     @Inject(WINDOW) public window: Window) {
        afterNextRender(() => {
            window.addEventListener('raychat_ready', function (ets) {
                if (/Android|iPhone/.test(window.navigator.userAgent)) {
                    (window as any).Raychat.setStyle({
                        width: '0px !important',
                        height: '0px !important',
                        pointerEvents: 'none',
                        shadowBox: '0 0 0 0 white !important',
                    });
                    (window as any).Raychat.setPosition({
                        bottom: '-100%',
                        right: '-100%',
                    });
                } else {
                    (window as any).Raychat.setStyle({
                        zIndex: '9 !important',
                        borderRadius: '100%',
                    });
                }
            });
           
        });
    }

    CsrStatus = signal(false);

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.addEventListener('offline', () => {
                this.notification.warning('آفلاین', 'ارتباط با اینترنت برقرار نیست', 3000);
            });

            window.addEventListener('online', () => {
                this.notification.success('آنلاین', 'ارتباط برقرار شد، لطفا صفحه را مجدد بارگزاری کنید', 3000);
            });

            if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
                navigator.serviceWorker.register('/custom-sw.js');
            }

            const wasPromptShown = localStorage.getItem('pwa-install-dismissed');
            if (!wasPromptShown && this.isMobile()) {
                setTimeout(() => {
                    window.addEventListener('beforeinstallprompt', (e: any) => {
                        e.preventDefault();
                        this.deferredPrompt = e;
                        this.showPWA = true;
                    });
                }, 1000);

                if (this.isIOS() && !this.isInStandaloneMode()) {
                    this.showInstallGuide = true;
                }
            }

                setTimeout(() => {
                    const notFoundEl = document.querySelector('.not-found');
                    if (notFoundEl) {
                      //  document.querySelector('.cdk-overlay-container')?.remove();
                        this.dialog.closeAll();
                    }
                }, 1);
        }
    }
      
    dismissInstallPrompt(): void {
        this.showPWA = false;
        this.deferredPrompt = null;
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('pwa-install-dismissed', 'true'); // کاربر رد کرد
        }
    }
        
    installApp(): void {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then(() => {
                if (isPlatformBrowser(this.platformId)) {
                    localStorage.setItem('pwa-install-dismissed', 'true'); // دیگه نشون نده
                }
                this.deferredPrompt = null;
                this.showPWA = false;
            });
        }
            }
    isIOS(): boolean {
        const ua = this.window.navigator.userAgent;
        return /iPhone|iPad|iPod/.test(ua);
    }

    isInStandaloneMode(): boolean {
        return ('standalone' in this.window.navigator) && (this.window.navigator as any).standalone;
    }

    dismissGuide() {
        this.showInstallGuide = false
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('pwa-install-dismissed', 'true'); // کاربر رد کرد
        }

    }
              
}
